<template>
  <div style="background-color: #06172a; height: 100vh">
    <b-row style="
        text-align: center;
        height: 70px;
        background-color: #f3f6f9;
        padding: 10px;
      " class="align-items-center">
      <b-col col class="text-left pl-3">
        <b-img src="_logo.png" rounded alt="Rounded image" class="d-inline-block mr-1 mb-1" style="height: 35px" />
      </b-col>
      <b-col col class="text-center">
        <b-badge variant="success" class="badge-glow">
          مدة الحضور : {{ (minutes < 10 ? "0" : "" ) + minutes }}:{{ (secondes < 10 ? "0" : "" ) + secondes }}
            </b-badge>
      </b-col>
      <b-col col class="text-right pr-3">
        <b-badge variant="info" class="badge-glow">
          الاسم : {{ user.full_name }}
        </b-badge>
      </b-col>
    </b-row>

    <b-spinner v-if="loading" style="width: 7rem; height: 7rem; position: fixed; right: 50vw; top: 40vh" class="mr-1"
      label="Large Spinner" />
    <iframe v-else :src="link" allow="geolocation *; microphone *; camera *; display-capture *;" allowFullScreen="true"
      webkitallowfullscreen="true" mozallowfullscreen="true"
      sandbox="allow-same-origin allow-scripts allow-modals allow-forms" style="width: 100%; height: 90%; border: 0"
      scrolling="no"></iframe>

  </div>
</template>

<script>
import Auth from "@/Apis/Auth";
import controller from "@/Controllers/OnlineSessionController";
import { FlipClock } from "@mvpleung/flipclock";
import sha1 from "js-sha1";
import AttendanceController from "@/Controllers/AttendanceController";
import SessionAttendanceController from "@/Controllers/SessionAttendanceController";
const ctrAttendanc = new SessionAttendanceController();
export default {
  components: {
    FlipClock,
  },
  async mounted() {
    this.timer();
    

  },
  data() {
    return {
      link: "",
      user: Auth.USER,
      minutes: 0,
      secondes: 0,
      loading: false,
    };
  },
  async created() {
    //
    clearInterval(window.VCInterval);
    // let user = Auth.USER;
    //  let id = localStorage.getItem("eduProgram");
    // let room = Auth.ROOM.find((a) => a.edu_program_id == id);
    // if (room) this.room = room;
    let ctr = new controller();
    this.loading = true;
    const online = await ctr.Show(this.$route.params.id, { with: ["attr"] });
    console.log(online);
    let params = {
      online_session_id: this.$route.params.id,
      user_id: Auth.USER.id,
    };

    // if (type == "") type = Auth.USER.account_type;
    let role = "MODERATOR";
    let password = "123456789";
    if (Auth.USER.account_type == "student") {
      role = "VIEWER";
      password = "1234567";
    }
    const data = `fullName=${encodeURIComponent(
      Auth.USER.full_name
    )}&role=${role}&meetingID=${online.id}&password=${password}&redirect=false`;
    // const data = `password=123456789&fullName=${Auth.USER.full_name}&meetingID=${item}&redirect=true`;
    const checksum = sha1(
      "join" + data + "9jR3Y9VaB5fAQZcsKfJNafIL6ynZMahfLnkIDb6U14c"
    );

    const link = `https://vc3.sunnah.live/bigbluebutton/api/join?${data}&checksum=${checksum}`;
    const res = await ctr.Join({ link, id: this.$route.params.id });
    this.loading = false;

    if (res[0]) {
      this.link = res[0];
      this.attendLecture = await ctrAttendanc.attendLecture(params);
      console.log(this.attendLecture);
      const att = await ctrAttendanc.getUserAttendLecture({
        user_id: Auth.USER.id,
        online_session_id: this.$route.params.id,
      });
      let oldTime = 0;
      att.forEach((element) => {
        oldTime += this.calculateTime(element);
      });
      this.minutes = oldTime;
    }

    // this.link = await ctr.joinLecture(
    //   "",
    //   "6d461532359c8747e54ae4533432b49004ee9a95"
    // );

    // this.$router.push("/");
  },
  methods: {
    calculateTime(data) {
      var diff = Math.abs(
        new Date(data.updated_at) - new Date(data.created_at)
      );
      return Math.floor(diff / 1000 / 60);
    },
    timer() {
      window.VCInterval = setInterval(() => {

        this.secondes++;
        if (this.secondes == 60) {
          this.minutes++;
          this.secondes = 0;
          console.log(this.attendLecture);
          ctrAttendanc.Updata(this.attendLecture, false);
        }

      }, 1000);
    },
    async handler(event) {
      // await ctrAttendanc.Updata(this.attendLecture);
    },
  },
};
</script>

<style>

</style>